import React from "react";
import { Seeker } from "../../types/seeker";
import OnboardingStatusBadge from "../OnboardingStatusBadge";
import { useZipLocation } from "../../hooks/useZipLocation";

const DEFAULT_LOCATION = "Location not provided";

interface SeekerProfileHeaderProps {
    seeker: Seeker;
}

export default function SeekerProfileHeader({ seeker }: SeekerProfileHeaderProps) {
    const computedLocation = useZipLocation(seeker.locationPostcode, DEFAULT_LOCATION);
    const initial = (seeker.name || "?").trim().charAt(0).toUpperCase();
    const joinedDate = new Date(seeker.joinedAt).toLocaleDateString();

    return (
        <div className="rounded-2xl border border-[#2C2731] bg-[#FFFCEF] shadow-[inset_0_0_0_1px_rgba(44,39,49,0.05)]">
            <div className="flex gap-4 rounded-2xl border border-[#2C2731] bg-[#2C2731] p-6 text-[#FEF6D6] shadow-[0_12px_24px_rgba(44,39,49,0.2)]">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#FFFCEF] text-2xl font-semibold text-[#2C2731]">
                    {initial || "?"}
                </div>

                <div className="flex flex-1 flex-col gap-2">
                    <div className="flex items-center gap-3">
                        <h3 className="text-xl font-semibold leading-7 ph-mask">{seeker.name}</h3>
                        <OnboardingStatusBadge status={seeker.onboardingStatus} />
                    </div>

                    <div className="space-y-1 text-sm text-[#F2EAC3]">
                        <div className="ph-mask">{seeker.email}</div>
                        <div className="ph-mask">{seeker.phone && seeker.phone.trim().length > 0 ? seeker.phone : "Phone not available"}</div>
                    </div>

                    <dl className="mt-2 grid gap-3 text-xs font-medium uppercase tracking-[0.12em] text-[#F2EAC3]/70 sm:grid-cols-2">
                        <div className="flex items-center gap-2">
                            <img src="/joindate.svg" alt="Join Date Icon" className="h-4 w-4" />
                            <span>Joined {joinedDate}</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <img src="/location.svg" alt="Location Icon" className="h-4 w-4" />
                            <span>{computedLocation}</span>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    );
}
